import { GROUPED_PRIVILEGES } from '@/entities/authentication';
import { privilegeGuardRoute } from '@/features/authenticate';
import { ClosureReportPage } from '@/pages/events';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_private/events/$eventUuid/closure-report',
)({
  component: ClosureReportPage,
  beforeLoad: () =>
    privilegeGuardRoute({ privileges: GROUPED_PRIVILEGES.eventClose }),
});
